import { render, staticRenderFns } from "./net-fee.vue?vue&type=template&id=50393774"
import script from "./net-fee.vue?vue&type=script&lang=js"
export * from "./net-fee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports